import React, { Component, useEffect, useState } from 'react';

import './Footer.css';

import en from '../../language/en/Footer.json';
import es from '../../language/es/Footer.json';
import {
	Container,
	Grid,
	Icon,
	Typography,
	Paper,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Divider,
	ListItemAvatar,
	Avatar,
	colors
} from '@material-ui/core';
import InboxIcon from '@material-ui/icons/Inbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MailIcon from '@material-ui/icons/Mail';
import LinkIcon from '@material-ui/icons/Link';
import FiberManualRecordOutlinedIcon from '@material-ui/icons/FiberManualRecordOutlined';
import axios from 'axios';

import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import config from '../../config/config.json';
/* const darkTheme = createMuiTheme({
	palette: {
		type: 'dark',
	},
}); */

const useStyles = makeStyles((theme) => ({
	textSecondary: {
		color: '#c1c1c1',
	},
	blueDark: {
		// color: '#c1c1c1',
		backgroundColor: theme.palette.info.dark,
		border: '1px solid'
	},
	accentColor: {
		color: theme.palette.secondary.light,
	},
	listItemRoot: {
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5),
		paddingLeft: theme.spacing(0),
	},
	largeIcon: {
		width: theme.spacing(11),
	},
	footerHeader: {
		marginBottom: theme.spacing(2),
		textTransform: "uppercase"
	},
}));

function ListItemLink(props) {
	const classes = useStyles();
	return <ListItem button component="a" {...props} className={classes.listItemRoot} />;
}

const Footer = ({ lang }) => {

	const classes = useStyles();
	// console.log('accentColor...', classes.accentColor)
	const selectedLanguage = (lang === 'en') ? en : es;
	// console.log('colors...', colors);

	// const { data, loading, error } = usePosts();
	// console.log('wp_error', error);

	// const [posts, setPosts] = useState([]);
	const [noticiasRecientes, setNoticiasRecientes] = useState([]);

	// async function getBlogPost() {
	// 	try {
	// 		const url = 'http://blog.scu.insmet.cu/wp-json/wp/v2/posts?per_page=5';
	// 		const response = await axios.get(url);
	// 		// console.log(response);
	// 		setPosts(response.data);
	// 	} catch (error) {
	// 		console.error(error);
	// 	}
	// }

	// useEffect(() => {
	// 	getBlogPost();
	// }, [])

	useEffect(() => {
		let url = `${config.apiBaseUrl}/noticias`;

		// obteniendo las noticias
		fetch(url)
			.then(
				res => {
					return res.json();
				}
			)
			.then(
				data => {
					console.log('noticias recientes => ', data.slice(0, 3));
					setNoticiasRecientes(data.slice(0, 3));
				}
			)
			.catch(
				err => {
					console.log("news error ", err);
				}
			);

		// cleanup
		return () => {
		}
	}, []);

	// // console.log('posts...', posts);
	// const postLinkList = posts.map((post) => (
	// 	<React.Fragment>
	// 		<ListItemLink href={post ? post.link : './'} target="_blank">
	// 			<ListItemText primary={<Typography variant="body2" > {post ? post.title.rendered : 'Cargando...'} </Typography>} />
	// 		</ListItemLink>
	// 		<Divider style={{ backgroundColor: '#fff8' }} />
	// 	</React.Fragment>
	// ));

	// noticias recientes
	const getIniciales = (autor) => {
		const autorArr = autor.split(' ');

		const n = autorArr[0][0].toLowerCase();
		let n1, ap1, ap2;
		if (autorArr.length == 3) {
			n1 = '';
			ap1 = autorArr[1][0].toLowerCase();
			ap2 = autorArr[2][0].toLowerCase();
		} else if (autorArr.length == 4) {
			n1 = autorArr[1][0].toLowerCase();
			ap1 = autorArr[2][0].toLowerCase();
			ap2 = autorArr[3][0].toLowerCase();
		}

		return n + n1 + ap1 + ap2;
	}
	const noticiasRecientesComponent = noticiasRecientes.map((noticia) => (
		<div className="row">
			<div className="col-md-3">
				<Avatar alt={noticia.autor} src={`./assets/files/avatar/all_trab/${getIniciales(noticia.autor)}.png`} className={classes.xl} />
			</div>
			<div className="col-md-9 recent-news-inner">
				{/* <Link to={"/new/" + noticia.nombre}>{noticia.titulo}</Link>
                    <p>{noticia.texto.substring(0, 51)}...</p> */}
				<ListItemLink href={noticia ? "/#/new/" + noticia.nombre : './'}>
					<ListItemText primary={<Typography variant="body2" > {noticia ? noticia.titulo : 'Cargando...'} </Typography>} />
				</ListItemLink>
				<p>{noticia.texto.substring(0, 51)}...</p>
				<Divider style={{ backgroundColor: '#fff8' }} />
			</div>
		</div>
	));

	return (
		<section id="footer" className="Footer">

			<div className="footer">
				<Container>

					<Grid container spacing={3}>

						<Grid item xs={12} sm={3}>
							<Avatar src="./assets/admin/layout/img/logo_scroll_2.png" alt="logo" className={classes.largeIcon + ' ' + classes.footerHeader} />
							<Typography align="justify" style={{ paddingRight: '10px' }} variant="body2">
								Suministramos información meteorológica y climática autorizada, sobre el estado y comportamiento futuro de la atmósfera.
								Contribuimos directamente al bienestar de la comunidad y al desarrollo sostenible.
							</Typography>

							<List>
								<ListItem>
									<ListItemAvatar>
										<Avatar className={classes.blueDark} >
											<LocationOnIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText primary="Dirección:" secondary={
										<Typography variant="body2" className={classes.textSecondary} >
											Casa #451 calle 4 esquina 17, Vista Alegre, Santiago de Cuba
										</Typography>
									} />
								</ListItem>
								<Divider style={{ backgroundColor: '#fff8' }} variant="inset" />
								<ListItem>
									<ListItemAvatar>
										<Avatar className={classes.blueDark}>
											<PhoneIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText primary="Teléfono:" secondary={
										<Typography
											variant="body2"
											className={classes.textSecondary}
										>
											+53 22 641656
											</Typography>
									} />
								</ListItem>
								<Divider style={{ backgroundColor: '#fff8' }} variant="inset" />
								<ListItem>
									<ListItemAvatar >
										<Avatar className={classes.blueDark}>
											<MailIcon />
										</Avatar>
									</ListItemAvatar>
									<ListItemText primary="Correo:" secondary={
										<Typography
											variant="body2"
											className={classes.textSecondary}
										>
											meteorologia@scu.insmet.cu
											</Typography>
									}
									/>
								</ListItem>
							</List>

						</Grid>

						<Grid item xs={12} sm={3}>
							<Typography variant="subtitle1" className={classes.footerHeader} >
								Sitios de Interés
							</Typography>
							<List >
								<ListItemLink href="http://www.insmet.cu" target="_blank">
									<ListItemText primary={<Typography variant="body2" >Instituto Nacional de Meteorología</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="./" target="_blank">
									<ListItemText primary={<Typography variant="body2" >Sociedad Meteorológica de Cuba</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="https://public.wmo.int/es" target="_blank">
									<ListItemText primary={<Typography variant="body2" >Organización Meteorológica Mundial</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="http://www.cmpscu.cu/sat" target="_blank">
									<ListItemText primary={<Typography variant="body2" >Sistema de Alerta Temprana</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="http://www.cmpscu.cu/api" target="_blank">
									<ListItemText primary={<Typography variant="body2" >Api Rest</Typography>} />
								</ListItemLink>
							</List>
						</Grid>

						<Grid item xs={12} sm={3}>
							<Typography variant="subtitle1" color="inherit" className={classes.footerHeader} >Servicios</Typography>
							<List >
								<ListItemLink href="/#/service/weather/stations">
									<ListItemText primary={<Typography variant="body2" > Estado del Tiempo </Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="/#/service/forecast">
									<ListItemText primary={<Typography variant="body2" >Pronóstico del Tiempo</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="/#/service/clime">
									<ListItemText primary={<Typography variant="body2" >Vigilancia del clima</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="/#/service/alerts">
									<ListItemText primary={<Typography variant="body2" >Avisos y Alertas</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="/#/service/hurricanes">
									<ListItemText primary={<Typography variant="body2" >Ciclones Tropicales</Typography>} />
								</ListItemLink>
								<Divider style={{ backgroundColor: '#fff8' }} />
								<ListItemLink href="/#/services/all" >
									<ListItemText primary={<Typography variant="body2" >Comerciales</Typography>} />
								</ListItemLink>
							</List>

						</Grid>

						<Grid item xs={12} sm={3}>
							<Typography variant="subtitle1" color="inherit" className={classes.footerHeader} >Noticias recientes</Typography>
							<List >
								{/* {postLinkList} */}
								{noticiasRecientesComponent}
							</List>

							<Typography variant="subtitle1" className={classes.footerHeader} style={{ marginTop: '20px' }}>Síguenos</Typography>
							<ul className="socials">
								<Divider style={{ backgroundColor: '#fff8', marginBottom: '10px' }} />
								<li><a href="https://www.facebook.com/Centro-Meteorol%C3%B3gico-Provincial-Santiago-de-Cuba-430142564038821" target="_blank"><Icon className="fa fa-facebook" /></a></li>
								<li><a href=""><Icon className="fa fa-linkedin" /></a></li>
								<li><a href=""><Icon className="fa fa-twitter" /></a></li>
								<li><a href=""><Icon className="fa fa-youtube" /></a></li>
								<Divider style={{ backgroundColor: '#fff8', marginTop: '10px' }} />
							</ul>

						</Grid>

					</Grid>

				</Container>
			</div>

			<Divider />

			<div className="footer-copyright">
				<Container>
					<p>Grupo de Informática y Comunicaciones &copy; 2016-2020. Centro Meteorológico Provincial, Santiago de Cuba.</p>
					<p>Versión 1.0</p>
				</Container>
			</div>

		</section>
	)
}

export default Footer;